<template>
  <filter-wrapper @submit="submit">
    <div class="filter__row">
      <div class="filter__item filter__item--search">
        <label class="filter__item__title">
          {{ $t('shared.component.filter.search') }}
        </label>
        <div class="filter__item__body">
          <i-input v-model="form.search" :clearable="true" />
        </div>
      </div>

      <div class="filter__item filter__item--datepicker">
        <label class="filter__item__title">
          {{ $t('shared.component.filter.period') }}
        </label>
        <div class="filter__item__body">
          <date-range-picker v-model="form.date" />
        </div>
      </div>

      <div class="filter__item filter__item--button">
        <i-button html-type="submit" type="primary">
          {{ $t('shared.component.filter.show_result') }}
        </i-button>
      </div>
    </div>
  </filter-wrapper>
</template>

<script>
  import FilterWrapper from '@shared/components/filter-base';
  import { mapActions } from 'vuex';
  import { initSearchStateByPeriod, parseSearchStateByPeriod } from '@shared/helpers/date_format';

  export default {
    components: {
      FilterWrapper
    },
    data: () => ({
      form: {
        search: '',
        date: initSearchStateByPeriod()
      }
    }),
    created() {
      this.submit();
    },
    methods: {
      ...mapActions('mailer/messages/table', ['search']),

      submit: function() {
        const { start, end } = parseSearchStateByPeriod(this.form.date);
        const { search = '' } = this.form;

        const params = {
          search: search,
          start: start,
          end: end
        };

        this.search(params);
      }
    }
  };
</script>
